<template>
	<div>
		<el-dialog class="close-private cps-dialog-icon-line-height"
			:visible.sync="visible"
			:title="$t('listPage.text.delete')"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="reinstall-tip">
				{{$t('ipv6.speechCraft.deleteIpv6CheckWarning', [rowInfo.ipv6Address])}}
			</div>
			<div class="reinstall-tip">
				{{$t('ipv6.speechCraft.afterDeleteIpv6Tip')}}
			</div>
<!-- 			<input type="checkbox" v-model="sureDelete" id="sureCharge"/>
			<label for="sureCharge">{{ $t('listPage.speechCraft.sureCharge') }}</label>
 -->			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDel">{{ $t('privateNetInstance.cancel') }}</el-button>
				<el-button @click="sureDel" type="primary">
					{{ $t('privateNetInstance.sure') }}
				</el-button>
			</div>
		</el-dialog>
		<jcb-opt-protect
			:visible.sync="operationProtectVisible"
			:action-type="OperationConstant.DELETE_IPV6"
			@success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';
import { debounce } from 'lodash';
export default {
	name: 'DeleteIpv6',
	mixins: [operationProtect],

	props: {
		visible: {
			type: Boolean,
			default: false
		},
		rowInfo: {
			type: Object,
			default: () => {}
		},
	},
	data() {
		return {
			// 操作保护弹框是否显示
			operationProtectVisible: false,
		};
	},
	computed: {
		OperationConstant: () => OperationConstant
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		/**
		 * 取消删除操作
		 */
		cancelDel() {
			this.handleClose();
		},
		/**
		 * 确定删除打开操作保护
		 */
		sureDel: debounce(function() {
            this.$emit('canNotDelete');
			this.openOperationProtect(OperationConstant.DELETE_IPV6, this.rowInfo, this.pageSource);
			this.handleClose();
		}, 800),
		/**
		 * 删除IPv6公网访问
		 * @param headers
		 */
		deleteIpv6(headers) {
            this.$emit('canNotDelete');
			const params = {
				ipv6AddressId: this.rowInfo.ipv6AddressId,
				region: this.rowInfo.region,
				clientToken: Normal.getClientToken(),
			};
			Ajax.del('/api/cps/ipv6Addresses/deleteBandwidth', params, { headers }).then(() => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
				this.$emit('refresh');
			}).catch(async (err) => {
				const { response } = err.data;
				const json = await response.json();
				this.$message.error(json.errmsg);
				if (json.errno === 20106) {
					this.$emit('refresh');
				}
			})
			.finally(() => {
				this.handleClose();
                this.$emit('canDelete');
			});
		},
	},

};
</script>

<style lang="scss">
	.close-private{
		.reinstall-confirm-checkbox{
			margin-top: 30px;
			margin-bottom: -20px;
			.jc-checkbox__label{
				color:rgb(121, 121, 121)
			}
		}
		.reinstall-tip {
			width:100%;
			font-size:15px;
			color:#797979;
			word-break: break-word;
			padding-bottom: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/DeleteIpv6.vue